import { combineReducers, configureStore } from "@reduxjs/toolkit";

import {
  authorizationReducer,
  categoriesReducer,
  profileReducer,
  cartsReducer,
  merchantReducer,
  creditsReducer,
  vouchersReducer,
  messagesReducer,
  customListReducer,
} from "./slices";

const reducers = combineReducers({
  authorizationReducer,
  profileReducer,
  categoriesReducer,
  cartsReducer,
  merchantReducer,
  creditsReducer,
  vouchersReducer,
  messagesReducer,
  customListReducer,
});

const store = configureStore({
  reducer: reducers,
});

export default store;
